import { ReactNode } from 'react'

type AstraMainLayoutProps = {
    navigation: ReactNode
    children: ReactNode
}

export const AstraMainLayout = ({ navigation, children }: AstraMainLayoutProps) => (
    <div className="flex h-screen flex-row-reverse gap-3 bg-gradient-brand-to-magic px-3 py-2">
        <div className="flex grow flex-col overflow-auto rounded-xl">
            <div className="h-full overflow-auto">{children}</div>
        </div>

        {navigation}
    </div>
)
